<template>
  <div>
    <el-form
      @submit.native.prevent
      class="cml-search-form"
      ref="listForm"
      :model="listForm"
      :inline="true"
      label-width="100px"
      size="mini"
    >
      <el-row>
        <el-form-item label="产品名称" prop="productName">
          <el-input
            v-model.trim="listForm.productName"
            clearable
            @keyup.13.native="onSearch"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button type="primary" @click="onReset">清空</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <div class="cml-button-group cml-tab-button-group">
      <el-tabs type="card" v-model="selectTab" @tab-click="tabChange">
        <el-tab-pane type="text" name="Tab1" label="草稿箱"></el-tab-pane>
        <el-tab-pane type="text" name="Tab2" label="待审核"></el-tab-pane>
        <el-tab-pane type="text" name="Tab3" label="已驳回"></el-tab-pane>
      </el-tabs>

      <span v-if="selectTab === 'Tab1'" class="cml-tabs-btn-group">
        <!-- 管理员不给批量导入产品 -->
        <el-button
          v-if="!isAdmin"
          type="primary"
          size="mini"
          v-hasPermission="'sample-manage/sample-list-import'"
          @click="importExcel"
          >批量导入产品</el-button
        >

        <!-- 一个权限 -->
        <el-button
          size="mini"
          v-if="
            permissionData.length === 1 &&
            !['2', '1'].includes(this.$store.getters.userSelf.user.adminType)
          "
          v-hasPermission="'sample-manage/sample-list-create'"
          @click="addBtn(false)"
          >发布单个产品</el-button
        >
        <!-- 多个权限 -->
        <el-button
          size="mini"
          v-else-if="['2', '1'].includes(this.$store.getters.userSelf.user.adminType)"
          v-popover:popover
          v-hasPermission="'sample-manage/sample-list-create'"
          >发布单个产品</el-button
        >
        <!-- 赠品-->
        <!-- 管理员不给批量导入赠品 -->
        <el-button
          v-if="!isAdmin"
          type="primary"
          size="mini"
          v-hasPermission="'sample-manage/sample-list-import-gift'"
          @click="importGiftExcel"
          >批量导入赠品</el-button
        >
        <el-button
          size="mini"
          :disabled="btnDisabled"
          v-hasPermission="'sample-manage/sample-list-submit'"
          @click="batchSubmit"
          >批量提交审核</el-button
        >
        <!-- 多个权限下拉框 -->
        <el-popover
          ref="popover"
          placement="bottom"
          trigger="click"
        >
          <span v-for="(item, index) in permissionOriginData" :key="index">
            <el-link v-if="!item.hiden" @click="addBtn(item)">{{ item.pageName }}</el-link>
          </span>
        </el-popover>
      </span>
    </div>

    <div v-show="selectTab === 'Tab1'">
      <CommonTable
        ref="CommonTableRefTab1"
        :loading="tableLoading"
        :tableHead="tableHeadTab1"
        :tableData="tableDataTab1"
        :tableParam="tableParamTab1"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.sampleVO.mainImage && row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <el-button
              v-if="row.type !== 'RAW_MATERIAL' && !row.sampleVO.mainImage"
              v-hasPermission="'sample-manage/sample-list-update'"
              class="setImg"
              @click="editBtn(row, 'img-box')"
              type="text">
            </el-button>
            <div v-if="row.type !== 'RAW_MATERIAL' && !row.sampleVO.mainImage" style="width: 55px; min-width: 55px;"></div>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #detailSlot="{ row }">
          <span
            v-if="
              row.type === 'RAW_MATERIAL'
                ? row.sampleVO.sampleAttachmentVOs
                : row.sampleVO.information
                ? row.sampleVO.information.replace(/<img.*?(?:>|\/>)/gi, '') ||
                  row.sampleVO.information.replace(
                    /<video.*?(?:>|\/>)/gi,
                    '',
                  ) ||
                  row.sampleVO.information.replace(/<[^>]+>/g, '')
                : ''
            "
            >已设置</span
          >
          <span v-else>
            未设置
            <el-button
              style="margin-left: 10px"
              v-hasPermission="'sample-manage/sample-list-update'"
              @click="editBtn(row, 'editor-box')"
              type="text"
              >设置</el-button
            >
          </span>
        </template>
        <template #operationSlot="{ row }">
          <el-button
            v-hasPermission="'sample-manage/sample-list-update'"
            @click="editBtn(row)"
            type="text"
          >修改</el-button>
          <el-button
            v-hasPermission="'sample-manage/sample-list-delete'"
            @click="operateBtn('delete', '删除', row.id)"
            type="text"
          >删除</el-button>
          <el-button
            type="text"
            v-hasPermission="'sample-manage/sample-list-copy'"
            @click="copySample(row)"
          >复制</el-button>
        </template>
      </CommonTable>
    </div>

    <div v-show="selectTab === 'Tab2'">
      <CommonTable
        ref="CommonTableRefTab2"
        :loading="tableLoading"
        :tableHead="tableHeadTab2"
        :tableData="tableDataTab2"
        :tableParam="tableParamTab2"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.sampleVO.mainImage && row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #operationSlot="{ row }">
          <el-button
            v-hasPermission="'sample-manage/sample-list-withdraw'"
            @click="operateBtn('withdraw', '撤回', row.id)"
            type="text"
          >撤回</el-button>
          <el-button
            type="text"
            v-hasPermission="'sample-manage/sample-list-copy'"
            @click="copySample(row)"
          >复制</el-button>
        </template>
      </CommonTable>
    </div>

    <div v-show="selectTab === 'Tab3'">
      <CommonTable
        ref="CommonTableRefTab3"
        :loading="tableLoading"
        :tableHead="tableHeadTab3"
        :tableData="tableDataTab3"
        :tableParam="tableParamTab3"
        @page-size-change="pageSizeChange"
        @select-change="selectChange"
        @sort-change="sortChange"
      >
        <template #idSlot="{ row }">
          <div class="cml-sample-info">
            <el-image
              v-if="row.sampleVO.mainImage && row.type !== 'RAW_MATERIAL'"
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="row.sampleVO.mainImage + $ImgQuality30"
              :preview-src-list="[row.sampleVO.mainImage + $ImgPreviewQuality]"
              :fit="fit"
            >
              <div slot="placeholder" class="sample-image-slot">
                加载中
              </div>
            </el-image>
            <div>
              <p>产品ID：{{ row.productId }} </p>
              <span @click="toDetail(row)">{{ row.productName }}</span>
            </div>
          </div>
        </template>
        <template #statusSlot="{ row }">
          <div class="cml-sample-info">
            <div>
              <p style="cursor: auto">{{ row.statusName }}</p>
              <el-popover
                v-if="row.status === 'REJECT'"
                placement="top"
                width="300"
                trigger="click"
                :content="'驳回意见：' + row.sampleCheckVO.rejectMark"
              >
                <el-button type="text" slot="reference">查看原因</el-button>
              </el-popover>
            </div>
          </div>
        </template>
        <template #operationSlot="{ row }">
          <el-button
            v-hasPermission="'sample-manage/sample-list-update'"
            @click="editBtn(row)"
            type="text"
            >修改</el-button
          >
          <el-button
            v-hasPermission="'sample-manage/sample-list-delete'"
            @click="operateBtn('delete', '删除', row.id)"
            type="text"
          >删除</el-button>
          <el-button
            type="text"
            v-hasPermission="'sample-manage/sample-list-copy'"
            @click="copySample(row)"
          >复制</el-button>
        </template>
      </CommonTable>
    </div>

    <!-- 导入excel -->
    <PackageImport
      v-if="category[0] === 'PACKING_MATERIAL'"
      ref="importDialog"
      @refresh="onSearch"
    />
    <ODMImport
      v-if="category[0] === 'ODM'"
      ref="importDialog"
      @refresh="onSearch"
    />
    <MBImport
      v-if="category[0] === 'MEMBRANE_CLOTH'"
      ref="importDialog"
      @refresh="onSearch"
    />
    <YLImport
      v-if="category[0] === 'RAW_MATERIAL'"
      ref="importDialog"
      @refresh="onSearch"
    />
    <GIFTmport
      ref="importGiftDialog"
      @refresh="onSearch"
    />

    <!-- 批量操作后的弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="resultDialogVisible"
    >
      <ResultDialog
        :showText="showText"
        :dialogResult="dialogResult"
        :tableDataField="'failResultList'"
        :showNameCol="true"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resultDialogClose" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ResultDialog from '@/components/ResultDialog';
import CommonTable from '@/components/CommonTable';
import PackageImport from '../publish-package-sample/Import.vue';
import ODMImport from '../publish-ODM-sample/Import.vue';
import MBImport from '../publish-membrane-sample/Import.vue';
import YLImport from '../publish-material-sample/Import.vue';
import GIFTmport from '../publish-gift-sample/Import.vue';
import { pageNameArr } from '@/utils/pageInfo';
import sampleMixin from '@/mixins/sampleMixin';
import { groupBy } from 'lodash';

export default {
  components: {
    ResultDialog,
    CommonTable,
    PackageImport,
    ODMImport,
    MBImport,
    YLImport,
    GIFTmport,
  },
  mixins: [sampleMixin],
  props: {},
  data() {
    return {
      isAdmin: true,
      listForm: {
        productName: '',
      },
      selectTab: 'Tab1',
      tableLoading: false,
      status: { Tab1: 'EDIT', Tab2: 'PENDING', Tab3: 'REJECT' },
      tableParamTab1: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableParamTab2: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableParamTab3: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab1: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        {
          label: '产品详情',
          prop: 'detail',
          slotColumn: true,
          slotName: 'detailSlot',
          width: 150,
        },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '类型', prop: 'typeName', width: 150 },
        { label: '编辑账号', prop: 'createByName', width: 150 },
        { label: '修改时间', prop: 'updateDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableHeadTab2: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        { label: '状态', prop: 'statusName', width: 150 },
        { label: '编辑账号', prop: 'createByName', width: 150 },
        { label: '提交时间', prop: 'sumbitDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableHeadTab3: [
        { label: '产品信息', prop: 'id', slotColumn: true, slotName: 'idSlot' },
        {
          label: '状态',
          prop: 'statusName',
          width: 150,
          slotColumn: true,
          slotName: 'statusSlot',
        },
        { label: '编辑账号', prop: 'createByName', width: 150 },
        { label: '审核时间', prop: 'checkDate', width: 150, sortable: true },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 150,
        },
      ],
      tableDataTab1: {},
      tableDataTab2: {},
      tableDataTab3: {},
      selectionTab1: [],
      selectionTab2: [],
      selectionTab3: [],
      onLoading: false,
      offLoading: false,
      permissionData: [],
      permissionOriginData: [],
      category: [],
      customerId: '',
      dialogResult: {},
      resultDialogVisible: false,
      showText: true,
      fit: 'contain'
    };
  },
  computed: {
    btnDisabled() {
      return this[`selection${this.selectTab}`].length < 1;
    },
    selectData() {
      return this[`selection${this.selectTab}`].length !== 1;
    }
  },
  watch: {
    selectTab() {
      this.getList();
    },
  },
  mounted() {
    // 管理员不给批量导入赠品
    this.isAdmin = this.$store.getters.userSelf.roles.some(item => item.code === 'cml-admin')
    this.$refs.CommonTableRefTab1.changeHeight(120);
    this.$refs.CommonTableRefTab2.changeHeight(120);
    this.$refs.CommonTableRefTab3.changeHeight(120);
    this.getList();
    const { category, customerId } = this.$store.getters.userSupplier;
    this.category = [category];
    this.customerId = customerId;
    // 判断是否具有多个权限
    this.permissionOriginData = pageNameArr;
    this.permissionData = this.category.reduce((prev, cur) => {
      if (this.permissionOriginData.findIndex(item => item.type === cur) > -1) {
        prev.push(cur);
      }
      return prev;
    }, []);
    if (['2', '1'].includes(this.$store.getters.userSelf.user.adminType)) {
      this.permissionOriginData = pageNameArr;
    }
    // 原料供应商——显示附件
    this.tableHeadTab1[1].label = this.category[0] === 'RAW_MATERIAL' ? '附件' : '产品详情';
  },
  methods: {
    onSearch() {
      this[`tableParam${this.selectTab}`].pageNo = 1;
      this.getList();
    },
    getList() {
      const params = {
        ...this[`tableParam${this.selectTab}`],
        data: this.listForm,
      };
      if (!params.orderBy) {
        params.orderBy = 'update_date desc';
      }
      params.data.status = this.status[this.selectTab];
      this.tableLoading = true;
      this.$http.sampleManage
        .getSampleList(params)
        .then(result => {
          this[`tableData${this.selectTab}`] = {
            list: result.data.list.map(item => {
              item.sampleVO =
                item[this.filterParam(item.type).listDataParam] || [];
              return item;
            }),
            total: result.data.total,
          };
          this[`selection${this.selectTab}`] = [];
          this.$refs[`CommonTableRef${this.selectTab}`].clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    addBtn(row) {
      // 单个权限
      if (!row) {
        row = this.permissionOriginData.find(
          item => item.type === this.permissionData[0],
        );
      }
      // 多个权限
      this.jumpUrl(row, 'add');
    },
    editBtn(row, scroll) {
      this.$refs[`CommonTableRef${this.selectTab}`].$refs.vxeTable.closeTooltip()
      this.jumpUrl(row, 'update', 'reload', scroll);
    },
    operateBtn(val, title, id) {
      this.$confirm(`确定${title}样品?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.sampleManage[`${val}Sample`]([id])
          .then(result => {
            this.$message.success(result.msg);
            this.onSearch();
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.tableLoading = false;
          });
      });
    },
    batchSubmit() {
      const selection = this[`selection${this.selectTab}`];
      if (Object.keys(groupBy(selection, 'type')).length > 1) {
        this.$message.error('请选择相同类型的样品进行提交审核');
        return;
      }
      const type = Object.keys(groupBy(selection, 'type'))[0];
      let err;
      let errMsg;
      // 包材
      if (type === 'PACKING_MATERIAL') {
        err = selection.filter(
          item => !item[this.filterParam(item.type).listDataParam].mainImage
        );
        errMsg = '主图片不能为空';
      }
      // ODM
      if (type === 'ODM') {
        err = selection.filter(
          item => !item[this.filterParam(item.type).listDataParam].mainImage,
        );
        errMsg = '主图片不能为空';
      }
      // 原料
      if (type === 'RAW_MATERIAL') {
        err = selection.filter(
          item =>
            !item[this.filterParam(item.type).listDataParam]
              .sampleAttachmentVOs,
        );
        errMsg = '附件内容不能为空(MSDS、TDS文件不能为空)';
      }
      // 膜布
      if (type === 'MEMBRANE_CLOTH') {
        err = selection.filter(
          item =>
            !item[this.filterParam(item.type).listDataParam].mainImage ||
            !item[this.filterParam(item.type).listDataParam].sampleAttachmentVOs || 
            !item[this.filterParam(item.type).listDataParam].detailImages,
        );
        errMsg = '主图片、材质细节图片和附件内容不能为空';
      }
      // 赠品
      if (type === 'GIFT_MATERIAL') {
        err = selection.filter(
          item =>
            !item[this.filterParam(item.type).listDataParam].mainImage ||
            !item[this.filterParam(item.type).listDataParam].information,
        );
        errMsg = '主图片和详情不能为空';
      }

      if (err.length > 0) {
        const result = {
          failResultList: err.reduce((prev, cur) => {
            prev.push({
              code: cur.productId,
              name: cur.productName,
              msg: errMsg,
            });
            return prev;
          }, []),
        };
        this.dialogResult = result;
        this.showText = false;
        this.resultDialogVisible = true;
        return false;
      }

      this.$confirm(`确认提交审核?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.sampleManage
          .batchSubmitSample(
            this[`selection${this.selectTab}`].map(item => item.id),
          )
          .then(result => {
            if (result.data.failNum === 0) {
              this.$message.success(result.msg);
            } else {
              this.dialogResult = result.data;
              this.showText = true;
              this.resultDialogVisible = true;
            }
            this.onSearch();
          })
          .catch(err => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.tableLoading = false;
          });
      });
    },
    importExcel() {
      this.$refs.importDialog.importDialog = true;
    },
    // 批量导入赠品
    importGiftExcel() {
      this.$refs.importGiftDialog.importDialog = true;
    },
    resultDialogClose() {
      this.resultDialogVisible = false;
      this.getList();
    },
    copySample(row) {
      this.$refs[`CommonTableRef${this.selectTab}`].$refs.vxeTable.closeTooltip();
      this.jumpUrl(row, 'copy', 'reload');
    }
  },
};
</script>

<style lang="less" scoped>
.download-file {
  display: inline-block;
  & > a {
    margin: 0 5px;
  }
}
.el-link {
  display: block;
  margin: 15px;
}
.setImg {
  position: absolute;
  width: 50px;
  height: 50px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 0;
  &::after {
    content: '产品主图';
    position: absolute;
    left: 0;
    top: 0;
    height: 16px;
    line-height: 16px;
    text-align: center;
    background: #555;
    color: #fff;
  }
  &::before {
    content: '设置';
    position: absolute;
    left: 12px;
    top: 23px;
    height: 16px;
    line-height: 16px;
    color: #AB0033;
  }
}
</style>
